import { logisticaTypes } from "../actions/types"
import { documentKey, normalizeBultos, todayDateOnly } from "../helpers/logisticaHelper"

const emptyCabecera = {
  sheetId: null,
  deliveryDate: "",
  loadDate: "",
  // Código de la forma de envío de GP; la planilla no trae otro dato del transporte
  transportCode: "",
  plate: "",
  status: null,
  createdBy: "",
  createdDate: "",
  cancelledBy: "",
  cancelledDate: "",
}

// Una planilla nueva arranca con la fecha de carga de hoy. Es una función para que al limpiar tome el día actual
const newCabecera = () => ({ ...emptyCabecera, loadDate: todayDateOnly() })

const initialState = {
  transports: [],
  cabecera: newCabecera(),
  // `customer` es el cliente elegido en el filtro ({ customerNumber, customerName }) o null
  filtroDocs: { fechaDesde: "", fechaHasta: "", customer: null },
  // Líneas activas de la planilla (traen lineId) seguidas de los documentos candidatos (facturas y transferencias)
  documentos: [],
  // documentKey de los documentos tildados
  selectedIds: [],
  // Líneas que ya no están vigentes: Replaced, Removed, Cancelled
  historial: [],
  buscarFiltro: { fechaDesde: "", fechaHasta: "", transportCode: "", documentNumber: "" },
  buscarResultados: [],
  // Cambios del operador sin guardar sobre la cabecera, la selección o las líneas
  dirty: false,
  // Drawer lateral de Logística: lo abre el botón del navbar
  drawerOpen: false,
}

// Una línea que llega sin bultos queda en 0: el operador tiene que cargarlos antes de guardar
const withPackages = (line) => ({
  ...line,
  packages: normalizeBultos(line.packages),
})

export const logisticaReducer =
  (
    state = initialState,
    action
  ) => {
    switch (action.type) {
      case logisticaTypes.SET_TRANSPORTS:
        return {
          ...state,
          transports: action.payload,
        }
      case logisticaTypes.SET_CABECERA_FIELD:
        return {
          ...state,
          cabecera: { ...state.cabecera, [action.payload.field]: action.payload.value },
          dirty: true,
        }
      case logisticaTypes.SET_CABECERA_FIELDS:
        return {
          ...state,
          cabecera: { ...state.cabecera, ...action.payload.fields },
          dirty: action.payload.dirty,
        }
      case logisticaTypes.SET_FILTRO_DOCS_FIELD:
        return {
          ...state,
          filtroDocs: { ...state.filtroDocs, [action.payload.field]: action.payload.value },
        }
      case logisticaTypes.LOAD_PLANILLA: {
        const { lines = [], ...cabecera } = action.payload
        const activas = lines
          .filter((l) => l.status === "Active")
          .map(withPackages)
        return {
          ...state,
          cabecera: { ...emptyCabecera, ...cabecera },
          documentos: activas,
          selectedIds: activas.map(documentKey),
          historial: lines.filter((l) => l.status !== "Active"),
          dirty: false,
        }
      }
      case logisticaTypes.SET_CANDIDATAS: {
        const { candidatas, keepSelected } = action.payload
        // Con keepSelected, los candidatos tildados siguen aunque el nuevo filtro (otro cliente, otras fechas) no
        // los traiga, con sus ediciones. Sin él (refresco tras un 602) quedan solo los que siguen disponibles
        const tildados = new Set(state.selectedIds)
        const conservados = state.documentos.filter(
          (d) => d.lineId || (keepSelected && tildados.has(documentKey(d)))
        )
        const yaEnGrilla = new Set(conservados.map(documentKey))
        const documentos = [
          ...conservados,
          ...candidatas
            .filter((c) => !yaEnGrilla.has(documentKey(c)))
            .map(withPackages),
        ]
        const disponibles = new Set(documentos.map(documentKey))
        return {
          ...state,
          documentos,
          selectedIds: state.selectedIds.filter((id) => disponibles.has(id)),
        }
      }
      case logisticaTypes.DESCARTAR_CANDIDATAS: {
        const enPlanilla = state.documentos.filter((d) => d.lineId)
        const guardadas = new Set(enPlanilla.map(documentKey))
        return {
          ...state,
          documentos: enPlanilla,
          selectedIds: state.selectedIds.filter((id) => guardadas.has(id)),
        }
      }
      case logisticaTypes.TOGGLE_SELECTED:
        return {
          ...state,
          selectedIds: state.selectedIds.includes(action.payload)
            ? state.selectedIds.filter((id) => id !== action.payload)
            : [...state.selectedIds, action.payload],
          dirty: true,
        }
      case logisticaTypes.EDIT_DOCUMENTO_FIELD:
        return {
          ...state,
          documentos: state.documentos.map((d) =>
            documentKey(d) === action.payload.key
              ? { ...d, [action.payload.field]: action.payload.value }
              : d
          ),
          dirty: true,
        }
      case logisticaTypes.SET_BUSCAR_FILTRO_FIELD:
        return {
          ...state,
          buscarFiltro: { ...state.buscarFiltro, [action.payload.field]: action.payload.value },
        }
      case logisticaTypes.SET_BUSCAR_RESULTADOS:
        return {
          ...state,
          buscarResultados: action.payload,
        }
      case logisticaTypes.RESET:
        return { ...initialState, cabecera: newCabecera(), transports: state.transports, drawerOpen: state.drawerOpen }
      case logisticaTypes.TOGGLE_DRAWER:
        return { ...state, drawerOpen: !state.drawerOpen }
      default:
        return state
    }
  }
